<template>
  <b-button
    :variant="buttonVariant"
    @click="onClick"
    v-html="buttonText"
    :disabled="isDisabled"
    >
    <b-modal title="Список ошибок" id="errorListModal" ref="errorListModal"
      hide-footer size="xl">
      <error-list :errors="errors" :scopedErrors="scopedErrors" />
    </b-modal>
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex'
import ErrorList from '@/components/content/education/training/tools/ErrorList.vue'

export default {
  name: 'ErrorListButton',
  components: {
    ErrorList
  },
  methods: {
    onClick() {
      this.$refs.errorListModal.show()
    }
  },
  props: ['errors', 'scopedErrors'],
  computed: {
    ...mapGetters({
      trainingErrors: 'training/getErrors'
    }),
    localScopedErrors() {
      if (this.scopedErrors) {
        return this.scopedErrors
      }
      return this.trainingErrors
    },
    category() {
      const count = { error: 0, warn: 0, info: 0 }
      if (this.errors) {
        this.errors.forEach((error) => {
          count[error.severity] += 1
        })
      } else if (this.localScopedErrors) {
        Object.values(this.localScopedErrors).forEach((errors) => {
          errors.forEach((error) => {
            count[error.severity] += 1
          })
        })
      }
      return count
    },
    isDisabled() {
      if (this.errors) {
        return this.errors.length === 0
      }
      if (this.localScopedErrors) {
        return !Object.values(this.localScopedErrors).some((scope) => scope.length !== 0)
      }
      return true
    },
    buttonVariant() {
      const count = this.category
      if (count.error) {
        return 'danger'
      }
      if (count.warn) {
        return 'warning'
      }
      if (count.info) {
        return 'info'
      }
      return 'outline-primary'
    },
    buttonText() {
      const count = this.category
      if (count.error) {
        return `<em class="fas fa-skull-crossbones"></em> Ошибок: ${count.error}`
      }
      if (count.warn) {
        return `<em class="fas fa-exclamation-triangle"></em> Предупреждений: ${
          count.warn}`
      }
      if (count.info) {
        return `<em class="fas fa-info"></em> Информация: ${count.info}`
      }
      return '<em class="fas fa-check-circle"></em> Ошибок нет'
    }

  }
}
</script>

<style scoped>

</style>
